import React from 'react';

import { LegacyText, LegacyTextList, LegacyBox } from '@gogame/components';
import { withForm } from '@gogame/form';

const AffectedDimensions = withForm({
  enableReinitialize: true,
})(({ entities, dimensionName }) => {
  return (
    <LegacyBox gutter={4} vertical={true} style={{ padding: '16px' }}>
      {entities.length === 1 ? (
        <LegacyText variant={'caption'} intensity={200}>
          {dimensionName}
        </LegacyText>
      ) : null}
      <LegacyTextList
        variant={'caption'}
        limit={1}
        count={entities.length}
        unitsName={`${dimensionName}s `}
      >
        {entities.map(({ Dimension }) => (
          <LegacyTextList.Item key={Dimension.id}>
            {Dimension.name}
          </LegacyTextList.Item>
        ))}
      </LegacyTextList>
    </LegacyBox>
  );
});

export default AffectedDimensions;
